/* src/app/footer/footer.component.css */
body {
  font-family:
    "Helvetica Neue",
    Helvetica,
    Arial,
    sans-serif;
}
/*# sourceMappingURL=footer.component.css.map */
